import { jsx as e, jsxs as F } from "react/jsx-runtime";
import m from "react";
import { s as y, F as C, a as p } from "./chunks/field-error.DDRV9OmH.js";
import { Flex as b } from "./flex.js";
import { L as h } from "./chunks/layout.BROMuy9M.js";
import { Spacer as x } from "./spacer.js";
import { Text as u } from "./text.js";
import { c as L } from "./chunks/index.rKuIKazb.js";
import './assets/fieldset.css';const d = ({
  children: i,
  ...r
}) => /* @__PURE__ */ e(u, { variant: "p-200", color: "c-high-contrast", ...r, children: i });
d.displayName = "Fieldset.Description";
const N = "_label_1ilgy_3", _ = {
  label: N
}, l = ({
  invalid: i,
  children: r,
  className: t,
  ...s
}) => /* @__PURE__ */ e(
  u,
  {
    variant: "p-200",
    color: i ? "sig-error" : "c-high-contrast",
    className: L(_.label, t),
    asChild: !0,
    children: /* @__PURE__ */ e("legend", { ...s, children: r })
  }
);
l.displayName = "Fieldset.Legend";
const a = ({
  label: i,
  description: r,
  caption: t,
  error: s,
  invalid: o,
  children: g,
  ...f
}) => {
  const c = m.useId(), n = m.useId();
  return /* @__PURE__ */ e(b, { direction: "column", asChild: !0, children: /* @__PURE__ */ F(
    "fieldset",
    {
      ...f,
      ...y({
        "aria-invalid": o,
        "aria-errormessage": s ? c : void 0,
        "aria-describedby": r ? n : void 0
      }),
      children: [
        i && /* @__PURE__ */ e(h, { margin: { bottom: i && r ? 200 : 0 }, asChild: !0, children: /* @__PURE__ */ e(l, { invalid: o, children: i }) }),
        r && /* @__PURE__ */ e(d, { id: n, children: r }),
        (i || r) && /* @__PURE__ */ e(x, { height: 400 }),
        g,
        (t || s) && /* @__PURE__ */ e(h, { margin: { top: 300 }, asChild: !0, children: s ? /* @__PURE__ */ e(C, { id: c, children: s }) : /* @__PURE__ */ e(p, { invalid: o, children: t }) })
      ]
    }
  ) });
};
a.displayName = "Fieldset";
a.Caption = p;
a.Description = d;
a.Label = l;
export {
  a as Fieldset
};
//# sourceMappingURL=fieldset.js.map
